import { Types } from '@convincely/utils/lib/inputs.js';
export const spreadProps = [
    'autocomplete',
    'autofocus',
    'disabled',
    'inputmode',
    'max',
    'min',
    'maxlength',
    'minlength',
    'name',
    'pattern',
    'placeholder',
    'readonly',
    'required',
    'step',
    'style',
    'tabIndex',
    'autocorrect',
    'autocapitalize',
];
export const textTypes = [Types.text, Types.suggest];
export const customValues = [Types.suggest, Types.radio];
export const selectValues = [Types.select, Types.suggest];
//# sourceMappingURL=props.js.map